export default __webpack_public_path__ + "static/media/Medium-branded-DeepRacer-GUI-bordered-945px-604px.ee0789a1.jpg";